import {IContentMapper} from "../base.content";
import {ListContentDTO, ListContent, ListContentItem} from "../list.content";
import {ImageListContent, ImageListContentItem, ImageListItemImage} from "../image-list.content";
import {LiveImageDTO} from "../../../image";
import {cmsTypeToString} from "../../constants";
import {parseDetails, formatDetails} from "./details";

export class ImageListContentMapper implements IContentMapper {
  toDTO(data: ListContent): ListContentDTO {
    return {
      type: cmsTypeToString(data.type),
      items: data.items.toArray().map((item) => ({
        primaryText: item.primaryText,
        secondaryText: item.secondaryText,
        details: formatDetails(item.details),
        avatar: item.avatar.url
      }))
    };
  }

  fromDTO(data: ListContentDTO): ImageListContent {
    return new ImageListContent({
      items: data.items.map((itemData) => new ImageListContentItem({
        primaryText: itemData.primaryText,
        secondaryText: itemData.secondaryText,
        details: parseDetails(itemData.details),
        avatar: new ImageListItemImage(new LiveImageDTO({
          original: itemData.avatar
        }))
      }))
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/club-cms/content/mappers/image-list.ts